import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  Box,
  VStack,
  Icon,
  Heading,
  Flex
} from '@chakra-ui/react';
import { CheckCircleIcon } from '@chakra-ui/icons';

/**
 * Modal to display when a user's account has been successfully upgraded
 */
const UpgradeSuccessModal = ({ isOpen, onClose, depositAmount }) => {
  // Calculate the bidding limit (10x deposit)
  const biddingLimit = depositAmount * 10;
  
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader p={0}>
          <Box 
            bg="#1E3A8A" 
            color="white" 
            py={6} 
            textAlign="center"
            borderTopRadius="md"
          >
            <Icon as={CheckCircleIcon} w={16} h={16} mb={2} />
            <Heading size="lg">Upgrade Successful!</Heading>
          </Box>
        </ModalHeader>
        <ModalCloseButton color="white" top="4" />
        
        <ModalBody py={6}>
          <VStack spacing={4} align="start">
            <Text fontSize="lg" fontWeight="medium">
              Your account has been upgraded to VIP Tier!
            </Text>
            
            <Text>
              Thank you for your deposit of ${depositAmount}. Your account now has access to all VIP features.
            </Text>
            
            <Box 
              w="100%" 
              bg="gray.50" 
              p={4} 
              borderRadius="md" 
              borderLeft="4px solid #1E3A8A"
            >
              <Heading size="sm" mb={3}>Your new benefits include:</Heading>
              <VStack align="start" spacing={2}>
                <Flex>
                  <CheckCircleIcon color="green.500" mr={2} />
                  <Text>Real-time auction listings (no delay)</Text>
                </Flex>
                <Flex>
                  <CheckCircleIcon color="green.500" mr={2} />
                  <Text>Full access to all car photos</Text>
                </Flex>
                <Flex>
                  <CheckCircleIcon color="green.500" mr={2} />
                  <Text>Visible auction times</Text>
                </Flex>
                <Flex>
                  <CheckCircleIcon color="green.500" mr={2} />
                  <Text>Price estimator access</Text>
                </Flex>
                <Flex>
                  <CheckCircleIcon color="green.500" mr={2} />
                  <Text>Submit inspection requests</Text>
                </Flex>
                <Flex>
                  <CheckCircleIcon color="green.500" mr={2} />
                  <Text>Bidding limit of ${biddingLimit.toLocaleString()}</Text>
                </Flex>
              </VStack>
            </Box>
            
            <Text fontSize="sm" color="gray.600">
              Your deposit is fully refundable and will be applied to your vehicle purchase.
            </Text>
          </VStack>
        </ModalBody>
        
        <ModalFooter>
          <Button colorScheme="blue" bg="#1E3A8A" onClick={onClose}>
            Start Exploring
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default UpgradeSuccessModal; 